// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3cUJg","sendOtp":"AuthorizeToLogin_sendOtp__QMnyc"};